module.exports = "<div style=\"padding-top: 100px;\">\n\t<span >{{version}}</span>\n</div>\n"